import ColumnSimpleForm from './ColumnSimpleForm.vue'

export default ColumnSimpleForm
